// src/App.js

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Kyetech from "./pages/Kyetech";
import AgentLogin from "./pages/AgentLogin";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AgentDashboard from "./pages/AgentDashboard";
import SuperAgentDashboard from "./pages/SuperAgentDashboard";
import Transactions from "./pages/Transactions";
import AdminUploadTickets from "./pages/AdminUploadTickets";
import AdminPaymentSettings from "./pages/AdminPaymentSettings";

import Waec from "./pages/waec";
import NotFound from "./pages/NotFound";

import PrivateRoute from "./components/PrivateRoute";

function App() {
  return (
    <Router>
      <Routes>

        {/* ================= PUBLIC ================= */}
        <Route path="/" element={<Kyetech />} />
        <Route path="/waec" element={<Waec />} />

        {/* ================= AUTH ================= */}
        <Route path="/agent/login" element={<AgentLogin />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route
          path="/agent/dashboard"
          element={
            <PrivateRoute allow="agent">
              <AgentDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/superagent/dashboard"
          element={
            <PrivateRoute allow={["superagent", "super-agent"]}>
              <SuperAgentDashboard />
            </PrivateRoute>
          }
        />

        {/* ================= ADMIN ONLY ================= */}
        <Route
          path="/admin/dashboard"
          element={
            <PrivateRoute allow="admin">
              <AdminDashboard />
            </PrivateRoute>
          }
        />
        <Route path="/admin/payment-settings" 
        element={
        <PrivateRoute allow="admin">
        <AdminPaymentSettings />
        </PrivateRoute>
        }
        />



        <Route
          path="/admin/transactions"
          element={
            <PrivateRoute allow="admin">
              <Transactions />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/upload"
          element={
            <PrivateRoute allow="admin">
              <AdminUploadTickets />
            </PrivateRoute>
          }
        />

        

        {/* ================= 404 ================= */}
        <Route path="*" element={<NotFound />} />

      </Routes>
    </Router>
  );
}

export default App;
